// Hook que trae el último mensaje del kine sin leer por el paciente.
// Usado por HomePaciente para mostrar el card "mensaje del kine".
//
// Sprint 3 B6: si hay mensaje pendiente, lo muestra como prop
// `mensajeKine` para que el paciente pueda click → /mensajes y abrir
// la conversación. Si NO hay mensaje pendiente, devuelve null y el
// card no se renderea.
//
// Polling 30s. Query simple LIMIT 1 — devolución del payload mínimo
// para evitar overhead innecesario en cada poll.

import { useCallback, useEffect, useState } from "react";
import { supabase } from "../client";

export interface UltimoMensajeKine {
  content: string;
  created_at: string;
}

const POLL_MS = 30_000;

export function useUltimoMensajeKine(
  pacienteId: string | null | undefined,
): UltimoMensajeKine | null {
  const [data, setData] = useState<UltimoMensajeKine | null>(null);

  const fetchOne = useCallback(async () => {
    if (!pacienteId) {
      setData(null);
      return;
    }
    const { data: row, error } = await supabase
      .from("mensajes")
      .select("content, created_at")
      .eq("paciente_id", pacienteId)
      .eq("sender", "kine")
      .is("read_at", null)
      .order("created_at", { ascending: false })
      .limit(1)
      .maybeSingle();
    if (error) {
      console.warn("[useUltimoMensajeKine] fetch error", error);
      return;
    }
    setData((row as UltimoMensajeKine | null) ?? null);
  }, [pacienteId]);

  useEffect(() => {
    if (!pacienteId) return;
    void fetchOne();
    const intervalId = setInterval(() => {
      void fetchOne();
    }, POLL_MS);
    const onFocus = () => {
      void fetchOne();
    };
    window.addEventListener("focus", onFocus);
    return () => {
      clearInterval(intervalId);
      window.removeEventListener("focus", onFocus);
    };
  }, [pacienteId, fetchOne]);

  return data;
}
